import { render, staticRenderFns } from "./QuizPieChart.vue?vue&type=template&id=475b7c38&scoped=true&"
import script from "./QuizPieChart.vue?vue&type=script&lang=js&"
export * from "./QuizPieChart.vue?vue&type=script&lang=js&"
import style0 from "./QuizPieChart.vue?vue&type=style&index=0&id=475b7c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b7c38",
  null
  
)

export default component.exports